var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-w-full gl-items-center gl-px-5 gl-py-4"},[_c('gl-loading-icon',{staticClass:"gl-pr-3",attrs:{"size":"sm"}}),_vm._v(" "),_c('div',{staticClass:"gl-flex gl-items-center"},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.preparing)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }